import axios from "./axiosInstance";

const base = {
    getAll: async (url) => {
        const response = await axios.get(url);
        return response.data;
    },

    add: async (url, data) => {
        const response = await axios.post(url, data);
        return response;
    },

    update: async (url, data) => {
        const response = await axios.put(url, data);
        return response;
    }
}

export default base;
